<template>
  <v-container 
    fluid primary
    class="my-0 py-12 px-0"
  >
    <v-row
      class="pb-12"
    >
      <v-col
        cols="12"
        md="6"
        class="px-0"
      >
        <v-img
          class=""
          height=""
          :src="getImg('livro.png')"
        >
        </v-img>
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="white--text px-11"
      >
        <v-chip small color="black"  class="white--text text--lighten-1 font-weight-bold text-uppercase">Promoção de Lançamento</v-chip>
        <h2 class="display-2 font-weight-bold pt-2 pb-6">
          <span class="barlow white--text text-uppercase">LIVRO LUZ & SOMBRA: A Honra e o Poder de Ser Você</span>
        </h2>
        <div class="title">
          <p>E o que realmente vale a pena nessa existência tão breve? Como ter a tão valorizada high performance, se desconhecemos quem somos de fato? Como ter o máximo desempenho humano, se não conhecemos esse ser que habita em nós? Como ter relações autênticas com as pessoas se não há uma relação plena com nós mesmos? Como ter propósito claro e cumprir missão de vida, se não sabemos quem somos verdadeiramente?</p>
        </div>
        <div class="subtitle-1 font-weight-regular">
          <p>Essas e outras questões profundas são abordadas nesse encantador livro no qual o autor Tadeu Belfort Jr aborda com maestria e leveza a complexidade do desenvolvimento humano. Desperte seu potencial máximo conhecendo suas sombras e despertando sua luz!</p>
        </div>
        <v-list
          disabled
          class="pt-0 pb-4 "
          color="transparent"
        >
          <v-list-item-group color="primary" class="">
            <v-list-item
              dense
              class="px-0 mx-0 py-0 my-0"
            >
              <v-list-item-icon class="pr-4 mr-0">
                <v-icon class="black--text">mdi-truck</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="pl-0 ml-0">
                <v-list-item-title class="white--text subtitle-1 font-weight-regular text-uppercase">
                  <span><b class="font-weight-black">Frete grátis</b> para o Brasil</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              dense
              class="px-0 mx-0 py-0 my-0"
            >
              <v-list-item-icon class="pr-4 mr-0">
                <v-icon class="black--text">mdi-cart</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="pl-0 ml-0">
                <v-list-item-title class="white--text subtitle-1 font-weight-regular text-uppercase">
                  <span>De <span style="text-decoration: line-through">R$ 49,00</span> <b class="font-weight-black"> por R$ 37,90</b></span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-btn
          x-large
          color="black white--text"
          class="font-weight-bold"
          :href="url"
          target="_blank"
        >Comprar Livro <v-icon class="pl-1">mdi-open-in-new</v-icon></v-btn>
        <div class="caption black--text">Você será direcionado para o PagSeguro</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    //url: 'https://pag.ae/7W2qAwdYK',
    url: 'https://bit.ly/2B0UwBm',
  }),
  methods: {
    getImg(i) {
      return require('@/assets/img/'+i)
    },
  },
}
</script>